import React from "react";
import Head from "next/head";
import { Field, Formik } from "formik";
import { Row, Col, Form, Label, Container, Button, Spinner, FormGroup, Input, FormText } from 'reactstrap';
import * as Yup from 'yup';
import { InputField } from "../components/InputField";
import Layout from "../components/Layout";
import { CreateNewEventRequestComponent, CreateNewEventRequestInput } from "../generated/apolloComponents";
import { withApollo } from "../lib/apollo";
import headTitle from "../components/ui/HeadTitle";

const MediaPartnershipPage = () => {
  const title = headTitle('Media Partnership');
  const description = 'Media partnership materials';
  return (
    <>
      <Head>
        <title>{title}</title>
        <meta key="og:title" property="og:title" content={title} />
        <meta key="og:url" property="og:url" content={`https://aiml.events/media-partnership`} />
        <meta key="og:image" property="og:image" content="https://aiml.events/static/img/banner.png" />
        <meta key="og:description" property="og:description" content={description} />
        <meta name="description" content={description} />
      </Head>
      <Layout>
      <main>
        <div className="py-4 bg-light">
          <Container>
            <div className="mb-3">
              <h2>Media Partnership</h2>
            </div>
            <p>Thank you for partnering with us. When mentioning AI &amp; ML Events on your websites and other materials please use the following:</p>
            <h4>Title</h4>
            <p>AI &amp; Machine Learning Events</p>
            <h4>Link</h4>
            <p>https://aiml.events</p>
            <h4>Description</h4>
            <p>Discover the best hand-picked artificial intelligence and machine learning events</p>
            <h4>Logo</h4>
            <p>
              <a href="/static/img/aimlevents-logo-256x256.png" download={true} className="btn btn-primary mr-3">Download logo 256x256 px</a>
              <a href="/static/img/aimlevents-logo-1024x1024.png" download={true} className="btn btn-primary">Download logo 1024x1024 px</a>
            </p>
            <p><img src="/static/img/aimlevents-logo-256x256.png" alt="AI &amp; ML Events"/></p>
          </Container>
        </div>
      </main>
    </Layout>
  </>
  );
};

export default withApollo(MediaPartnershipPage);
